export default [
  {
    name: 'Payment Type',
    type: 'radio',
    value: '',
    slug: 'payment-type',
    classes: 'full',
    options: [
      'Destination Wedding',
      'Group',
      'Deposit',
      'Incremental/Final Payment',
      'Wedding Registry Payment'
    ],
    required: true,
    show: true
  },
  {
    name: 'Your Name',
    type: 'text',
    value: '',
    slug: 'name',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Group Name',
    type: 'text',
    value: '',
    slug: 'group-name',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'payment-type',
        values: ['Group']
      }
    ],
    show: true
  },
  {
    name: 'Bride and Groom\'s Name',
    type: 'dynamic-select',
    dataUrl: 'destination-weddings/all',
    dataField: 'name',
    options: [],
    value: '',
    slug: 'wedding',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'payment-type',
        values: ['Destination Wedding', 'Wedding Registry Payment']
      }
    ],
    show: true
  },
  {
    name: 'Advisor',
    type: 'dynamic-select',
    dataUrl: 'agents/all',
    dataField: 'name',
    options: [],
    value: '',
    slug: 'travel-adviser',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment']
      }
    ],
    show: true
  },
  {
    name: 'Payment Amount',
    type: 'number',
    value: '',
    slug: 'amount',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Phone Number',
    type: 'text',
    value: '',
    slug: 'phone-number',
    classes: 'half',
    required: true,
    // conditions: [
    //   {
    //     operator: '==',
    //     field: 'payment-type',
    //     values: ['Wedding Registry Payment']
    //   }
    // ],
    show: true
  },
  {
    name: 'Email Address',
    type: 'text',
    value: '',
    slug: 'email-address',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'payment-type',
        values: ['Wedding Registry Payment']
      }
    ],
    show: true
  },
  {
    name: 'Complete and Accurate Traveler Name and Birth Dates',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'It is imperative that First Discount Travel has each traveler\'s complete and accurate name and birth date information. Traveler\'s name must match the name as it appears on his or her passport book. A Passport booklet with a minimum of 6 months validity is required for travel. This means your passport can\'t expire prior to 6 months after your return flight. <a href="http://travel.state.gov/passport/get/first/first_830.html" target="_blank">Please click here for details on how to obtain or renew your passport</a>. A valid passport book is required for air travel out of and into the United States. Other identification, such as a passport card or driver\'s license is not sufficient and will result in denied boarding.',
    conditions: [
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'I have already provided complete and accurate traveler names and birth dates for EVERY traveler on this reservation.',
    type: 'toggle',
    value: false,
    slug: 'already-provided-traveler-info',
    classes: 'full',
    required: false,
    conditions: [
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Passport Information',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'Each traveler\'s name and birth date must match his or her passport book exactly. All travelers, including minors, must have a passport book to travel outside of the United States. Each traveler\'s First, Middle and Last Name are required.',
    conditions: [
      {
        operator: '==',
        field: 'already-provided-traveler-info',
        values: [false]
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Number of Travelers',
    type: 'number',
    value: 1,
    max: 6,
    min: 1,
    classes: 'full',
    slug: 'number-of-travelers',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'already-provided-traveler-info',
        values: [false]
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Traveler Passport Information',
    type: 'numeric-repeater',
    numberField: 'number-of-travelers',
    subFields: [],
    classes: 'full',
    slug: 'traveler-information',
    required: false,
    subFieldTemplate: [
      {
        name: 'First Name',
        type: 'text',
        value: '',
        slug: 'first-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Middle Name',
        type: 'text',
        value: '',
        slug: 'middle-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Last Name',
        type: 'text',
        value: '',
        slug: 'last-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Date Of Birth',
        type: 'datepicker',
        value: '',
        slug: 'date-of-birth',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Email',
        type: 'text',
        value: '',
        slug: 'email',
        classes: 'fifth',
        required: false
      }
    ],
    conditions: [
      {
        operator: '==',
        field: 'already-provided-traveler-info',
        values: [false]
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Special Request or Message To Travel Advisor',
    type: 'textarea',
    value: '',
    slug: 'special-message-to-travel-advisor',
    classes: 'full',
    required: false,
    show: true
  },
  {
    name: 'Special Message To Bride/Groom',
    type: 'textarea',
    value: '',
    slug: 'special-message-to-bride-and-groom',
    classes: 'full',
    required: false,
    conditions: [
      {
        operator: '==',
        field: 'payment-type',
        values: ['Wedding Registry Payment']
      }
    ],
    show: true
  },
  {
    name: 'Travel Protection Insurance',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'Travel insurance is highly recommended and we offer several options, including coverage for pre-existing conditions and "cancel for any reason" (if available). Please ask your travel advisor for details. If insurance is declined, the package price will be non-refundable even in the case of weather issues, flight cancellations or travel interruptions. Please note that many health insurance policies, including Medicare, do not provide coverage outside of the United States. Furthermore, travel protection and assistance provided by your credit card company may be very limited.',
    conditions: [
      {
        operator: '==',
        field: 'already-provided-traveler-info',
        values: [false]
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Travel Protection Option',
    type: 'radio',
    value: '',
    slug: 'travel-protection-option',
    classes: 'full',
    options: [
      'Yes, I would like information about purchasing travel protection at an additional cost',
      'No, I decline travel protection and understand I will be responsible for any change or cancellation penalties',
      'I have already spoken to a travel advisor who is aware of the plan I would like to purchase'
    ],
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'already-provided-traveler-info',
        values: [false]
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'By selecting this option, I understand that I am responsible for ensuring I have adequate coverage for trip cancellation and/or interruption and that I am responsible any uncovered losses.',
    type: 'toggle',
    value: false,
    slug: 'travel-protection-understood',
    classes: 'full',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'travel-protection-option',
        values: ['No, I decline travel protection and understand I will be responsible for any change or cancellation penalties']
      },
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Payment Information',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'This amount may be processed by each travel provider directly and appear on your statement separately. By submitting the information on this form, you are authorizing First Discount Travel to process this payment on your account on your behalf. Your card will not be charged immediately. Payment will be processed and charged to your card within three business days.',
    show: true
  },
  {
    name: 'Cardholder Name',
    type: 'text',
    value: '',
    slug: 'cardholder-name',
    classes: 'full',
    required: true,
    show: true
  },
  {
    name: 'Billing Address',
    type: 'text',
    value: '',
    slug: 'billing-address',
    classes: 'full',
    required: true,
    show: true
  },
  {
    name: 'City',
    type: 'text',
    value: '',
    slug: 'billing-city',
    classes: 'third',
    required: true,
    show: true
  },
  {
    name: 'State',
    type: 'text',
    value: '',
    slug: 'billing-state',
    classes: 'third',
    required: true,
    show: true
  },
  {
    name: 'Zipcode',
    type: 'text',
    value: '',
    slug: 'billing-zipcode',
    classes: 'third',
    required: true,
    show: true
  },
  {
    name: 'Credit Card Number',
    type: 'encrypted',
    value: '',
    slug: 'credit-card-number',
    classes: 'full',
    required: true,
    show: true
  },
  {
    name: 'Expiration Month',
    type: 'text',
    value: '',
    slug: 'credit-card-expiration-month',
    classes: 'third',
    required: true,
    show: true
  },
  {
    name: 'Expiration Year',
    type: 'text',
    value: '',
    slug: 'credit-card-expiration-year',
    classes: 'third',
    required: true,
    show: true
  },
  {
    name: 'CVV',
    type: 'encrypted',
    value: '',
    slug: 'credit-card-cvv',
    classes: 'third',
    required: true,
    show: true
  }
];